import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Homepage from './Homepage/Homepage';
import ConfirmationPage from './Confirmation/Confirm';
import Journal from './Journal/Journal';
import UnsubscribePage from './Confirmation/Unsubbed';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// The admin studio is available only in the local development server.
const Automation = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./Automation/Automation')) : null;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#fff',
            color: '#333',
          },
          success: {
            duration: 4000,
            iconTheme: {
              primary: '#ec4899',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
          },
        }}
      />
      <Routes> 
        <Route path="/" element={<Homepage />} />
        <Route path="/confirm/:token" element={<ConfirmationPage />} />
        <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
        <Route path="/journal/*" element={<Journal />} />
        {Automation && <Route path="/automation" element={<React.Suspense fallback={<p>Loading…</p>}><Automation /></React.Suspense>} />}
        <Route path="*" element={<p className="p-8">Page not found.</p>} />
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
